import React from 'react';

import noGatewayImage from 'assets/images/no-gateway.png';

import { Button } from 'ui/Button';

import styles from 'assets/scss/modules/Gateways/Gateways.module.scss';

interface Props {
  variant: 'empty' | 'no-results';
  onAdd?: () => void;
}

const TEXT: Record<Props['variant'], string> = {
  empty: 'No gateways yet',
  'no-results': 'No gateways found',
};

export const EmptyState: React.FC<Props> = ({ variant, onAdd }) => (
  <div className={styles.emptyState}>
    <img src={noGatewayImage} alt="" className={styles.emptyImage} />
    <p className={styles.emptyText}>{TEXT[variant]}</p>
    {variant === 'empty' && onAdd && (
      <Button size="small" className={styles.emptyButton} onClick={onAdd}>
        Add first gateway
      </Button>
    )}
  </div>
);
